import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import useScreenSize from './useScreenSize';
import { useBreakpoint } from './useBreakpoint';
import { Category, GetCategoriesResponse } from '@/api/types/categories.types';
import { GET_CATEGORIES } from '@/api/queries/categories.queries';
import { categoriesMock } from '@/__e2e__/mock/categoriesMock';

export function useCategories(isOpen: boolean) {
  const { i18n } = useTranslation();
  const { isLarge } = useScreenSize();
  const { isDesktop } = useBreakpoint();

  const { data: { categories = [] } = {}, loading } =
    useQuery<GetCategoriesResponse>(GET_CATEGORIES, {
      skip: !isOpen,
      variables: { isDesktop: isLarge || isDesktop },
    });
  return {
    categories: (loading
      ? categoriesMock(i18n.language).categories
      : categories) as Category[],
    loading,
  };
}
